export const FINANCIAL_REPORT_PERMISSION = "financial_report";
export const ORDERS_VIEW_PERMISSION = "orders_view";
export const FINANCIAL_ONLY_EMAILS = ["tuanah252@gmail.com"];

export function hasPermission(permission, key) {
  return Array.isArray(permission) && permission.includes(key);
}

export function isFinancialOnlyEmail(user) {
  return FINANCIAL_ONLY_EMAILS.includes(String(user || "").trim().toLowerCase());
}

export function canSeeFinancialReport(admin, permission, user) {
  return (
    admin === true ||
    hasPermission(permission, FINANCIAL_REPORT_PERMISSION) ||
    isFinancialOnlyEmail(user)
  );
}

export function isOrdersViewAccount(admin, permission) {
  if (admin === true) return false;
  return hasPermission(permission, ORDERS_VIEW_PERMISSION);
}

export function isFinancialOnlyAccount(admin, permission, user) {
  if (admin === true || isOrdersViewAccount(admin, permission)) return false;
  return hasPermission(permission, FINANCIAL_REPORT_PERMISSION) || isFinancialOnlyEmail(user);
}
